import api from '@/api';
import {
  PortoPolicyVoucher,
  PortoPolicyVoucherRequest,
  PortoPolicy,
  PortoPolicyBenefit,
  PortoPolicyBenefitListRequest,
} from './porto-policies.types';

export const API_BASE_URL = `/porto/policies`;

export default {
  async list(LicensePlate?: string) {
    const result = (await api.get(API_BASE_URL, { LicensePlate })) as unknown;

    return result as PortoPolicy[];
  },

  async listBenefit(params?: PortoPolicyBenefitListRequest) {
    const result = (await api.get(`${API_BASE_URL}/perks`, params)) as unknown;

    return result as PortoPolicyBenefit[];
  },

  async listVouncher(params?: PortoPolicyVoucherRequest) {
    const result = (await api.get(
      `${API_BASE_URL}/vouchers`,
      params,
    )) as unknown;

    return result as PortoPolicyVoucher;
  },
};
